import React, { useEffect } from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const C = {
  darkBlue: "#0C1F2F",
  navy: "#0057A8",
  gold: "#FFCD00",
  gray: "#F5F7FA",
  softGold: "#c2ed80",
};

export default function PrivacidadPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const politicas = [
    {
      title: "Recopilación de información",
      text: "ELÉCTRICA GRM recopila únicamente la información de contacto proporcionada voluntariamente por el usuario a través de nuestros formularios, correos electrónicos o líneas de WhatsApp, necesaria para la cotización y despacho de pedidos.",
    },
    {
      title: "Uso de la información",
      text: "Los datos de contacto y detalles del proyecto proporcionados son utilizados exclusivamente para la elaboración de proformas, gestión logística de envíos y comunicación de soporte post-venta.",
    },
    {
      title: "No comercialización de datos",
      text: "Garantizamos que ELÉCTRICA GRM no vende, alquila ni comparte su base de datos de clientes con agencias de publicidad u otras entidades no relacionadas con la operación comercial directa.",
    },
    {
      title: "Seguridad de los datos",
      text: "Mantenemos medidas de seguridad organizativas para proteger la información de nuestros clientes comerciales, asegurando que los datos de facturación y direcciones de obra se manejen con estricta confidencialidad.",
    },
    {
      title: "Uso de herramientas analíticas",
      text: "Nuestro sitio web puede utilizar herramientas básicas de análisis de tráfico para comprender las preferencias de nuestros visitantes y mejorar la presentación de nuestros catálogos de marcas.",
    },
    {
      title: "Control de su información",
      text: "En cualquier momento, usted como cliente o prospecto comercial puede solicitar la actualización o eliminación de sus datos de contacto de nuestra base de datos de atención al cliente.",
    },
    {
      title: "Contacto de privacidad",
      text: "Si tiene dudas sobre el manejo de su información comercial, puede escribirnos directamente a gerencia@electricagrm.com.",
    },
  ];

  return (
    <Box
      sx={{
        background: C.gray,
        minHeight: "100vh",
        // Aumentamos el padding top para que el navbar no tape el contenido
        pt: { xs: "120px", md: "140px" },
        pb: { xs: 8, md: 10 },
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: C.darkBlue,
            mb: 2,
            fontSize: { xs: "2rem", md: "2.8rem" },
          }}
        >
          Política de Privacidad
        </Typography>
        <Typography
          sx={{ color: "#5c6c7a", mb: 6, fontSize: "1.1rem", lineHeight: 1.6 }}
        >
          En ELÉCTRICA GRM respetamos la confidencialidad de sus datos
          personales y comerciales. A continuación, detallamos el tratamiento de
          su información.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            background: "#fff",
            p: { xs: 3, md: 5 },
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
          }}
        >
          {politicas.map((item, index) => (
            <Box key={index}>
              <Typography
                variant="h6"
                sx={{
                  color: C.navy,
                  fontWeight: 750,
                  mb: 1,
                  fontSize: "1.15rem",
                }}
              >
                {index + 1}. {item.title}
              </Typography>
              <Typography
                sx={{ color: "#4e5f6e", lineHeight: 1.7, fontSize: "1rem" }}
              >
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Botón movido a la parte inferior y centrado */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <Button
            onClick={() => window.close()}
            startIcon={<ArrowBackIcon />}
            sx={{
              color: C.white,
              background: C.gold,
              fontWeight: 700,
              textTransform: "none",
              fontSize: "1rem",
              px: 4,
              py: 1.5,
              borderRadius: "50px",

              transition: "all 0.3s ease",
              "&:hover": {
                background: C.softGold,
                transform: "translateY(-3px)",
              },
            }}
          >
            Cerrar esta pestaña
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
